export const styles = {
  container: {
    padding: "0 20px",
    backgroundColor: "#FFFFFF",
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
  purchasedList: {
    padding: "0 20px",
    flex: 1,
    overflowY: "auto",
  },
  header: {
    width: "100%",
    flexShrink: 0,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "20px 0",
  },
  title: {
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "24px",
    lineHeight: "130%",
    letterSpacing: "0",
  },

  selectBox: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    width: "100%",
  },

  sortBox: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    gap: "16px",
  },

  ArrowsDiagram: {
    width: "24px",
    height: "24px",
    cursor: "pointer",
  },

  select: {
    width: "220px",
    backgroundColor: "#F7F9FB",
    color: "#9DA6B0",
    borderRadius: "12px",
    height: "36px",
    fontSize: "14px",
    ".MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    ".MuiSvgIcon-root": {
      color: "#9DA6B0",
    },
  },
};
